import { render, staticRenderFns } from "./PageDiscover.vue?vue&type=template&id=0a821e46&"
import script from "./PageDiscover.vue?vue&type=script&lang=ts&"
export * from "./PageDiscover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports